import { render, staticRenderFns } from "./NavigateCard.vue?vue&type=template&id=6b493cc0&scoped=true&"
import script from "./NavigateCard.vue?vue&type=script&lang=ts&"
export * from "./NavigateCard.vue?vue&type=script&lang=ts&"
import style0 from "./NavigateCard.vue?vue&type=style&index=0&id=6b493cc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b493cc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
